

<div class="row mb-4">

  <div class="cards-config">
    <div class="card content config ">
      <h3 class="mb-4"><span><img src="../../../assets/images/icon-menu03.svg"></span>{{ 'DASHBOARD_USUARIOS_ONLINE' | translate }}</h3>
      <div class="sidebar">

                <!-- Botão para carregar a lista -->
                <button *ngIf="!onlineUsersLoaded && !isLoadingChat" class="btn btn-primary" (click)="loadOnlineUsers()">
                  <i class="fa fa-sync-alt"></i> Carregar usuarios online
                </button>
            
                <!-- Indicador de carregamento -->
                <div *ngIf="isLoadingChat">
                  <i class="fa fa-spin fa-spinner me-2"></i> Carregando...
                </div>

        <ul class="ul-user" *ngIf="!isLoadingChat && onlineUsersLoaded">
          <li *ngFor="let user of users" class="li-user">
              <div style="display: flex; align-items: center;"  class="btn btn-secondary icon">
                <div *ngIf="user.online" style="width: 20px; height: 20px; border-radius: 50%; background-color: green; margin-right: 1px;"></div>
                {{ user.nome }} 
              </div>
          </li>
        </ul>

        
      </div>
    </div>

    <div class="card content config ">
      <h3 class="mb-4"><span><img src="../../../assets/images/icon-menu02.svg"></span>{{ 'DASHBOARD_MEUS_TICKETS' | translate }}</h3>

      <div class="sidebar">
                <!-- Botão para carregar a lista -->
                <button *ngIf="!myTicketsLoaded && !isLoadingMyTickets" class="btn btn-primary" (click)="loadMyTikcets()">
                  <i class="fa fa-sync-alt"></i> Meus Tickets
                </button>
            
                <!-- Indicador de carregamento -->
                <div *ngIf="isLoadingMyTickets">
                  <i class="fa fa-spin fa-spinner me-2"></i> Carregando...
                </div>


        <div *ngIf="myTicketsLoaded && !isLoadingMyTickets">
          <h3> Total de {{myticketsTotal}} tickets </h3>      
            <ul class="ul-user" *ngIf="!isLoadingChat">
              <li *ngFor="let status of mytickets" class="li-user">
                <a  [routerLink]="['/tickets']" >
                <!-- [queryParams]="{ status: status.id, myticket:true }"> -->
                  <div style="display: flex; align-items: center;"  class="btn btn-secondary icon">
                    <label><strong>{{ status.total }}</strong> {{ status.status }}  </label>
                  </div>
                </a>
              </li>
            </ul>
          <p></p>
        </div>


      </div>

    </div>

    <div class="card content config">
      <h3 class="mb-4">
        <span><img src="../../../assets/images/icon-menu-chat.svg"></span>
        {{ 'DASHBOARD_FILA_ATENDIMENTO' | translate }}
      </h3>
    
      <div class="sidebar">
        <!-- Botão para carregar a lista -->
        <button *ngIf="!usersLoaded && !isLoadingFilaAtendimento" class="btn btn-primary" (click)="loadUsers()">
          <i class="fa fa-sync-alt"></i> Carregar lista de atendimento
        </button>
    
        <!-- Indicador de carregamento -->
        <div *ngIf="isLoadingFilaAtendimento">
          <i class="fa fa-spin fa-spinner me-2"></i> Carregando...
        </div>
    
        <!-- Lista de Assuntos e Operadores -->
        <div *ngIf="usersLoaded && !isLoadingFilaAtendimento">
          <div *ngFor="let assunto of atendimentos" class="assunto-container">
            <!-- Nome do Assunto -->
            <h4 class="assunto-titulo">{{ assunto.nomeAssuno }}</h4>
            <ul class="ul-user">
              <li *ngFor="let user of assunto.operadores" class="li-user">
                <div style="display: flex; align-items: center;" class="btn btn-secondary icon">
                  <div 
                    style="width: 20px; height: 20px; border-radius: 50%; margin-right: 5px;"
                    [ngStyle]="{'background-color': user.online ? 'green' : ''}">
                  </div>
                  {{ user.nome }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    

    <div class="card content config ">
      <h3 class="mb-4"><span><img src="../../../assets/images/icon-menu02.svg"></span>Dashboard 04</h3>
      <div class="sidebar">
      </div>
    </div>

    <div class="card content config ">
      <h3 class="mb-4"><span><img src="../../../assets/images/icon-menu02.svg"></span>Dashboard 05</h3>
      <div class="sidebar">
      </div>
    </div>

    <div class="card content config ">
      <h3 class="mb-4"><span><img src="../../../assets/images/icon-menu02.svg"></span>Dashboard 06</h3>
      <div class="sidebar">
      </div>
    </div>

    <div class="card content config ">
      <h3 class="mb-4"><span><img src="../../../assets/images/icon-menu02.svg"></span>Dashboard 07</h3>
      <div class="sidebar">
      </div>
    </div>
    
    <div class="card content config ">
      <h3 class="mb-4"><span><img src="../../../assets/images/icon-menu02.svg"></span>Dashboard 08</h3>
      <div class="sidebar">
      </div>
    </div>

  </div>


</div>